function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id = 0;
function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}
import { nanoid } from 'nanoid/non-secure';
import EventManager from '@uppy/utils/lib/EventManager';
import ProgressTimeout from '@uppy/utils/lib/ProgressTimeout';
import ErrorWithCause from '@uppy/utils/lib/ErrorWithCause';
import NetworkError from '@uppy/utils/lib/NetworkError';
import isNetworkError from '@uppy/utils/lib/isNetworkError';
import { internalRateLimitedQueue } from '@uppy/utils/lib/RateLimitedQueue';

// See XHRUpload
function buildResponseError(xhr, error) {
  if (isNetworkError(xhr)) return new NetworkError(error, xhr);
  var err = new ErrorWithCause('Upload error', {
    cause: error
  });
  err.request = xhr;
  return err;
}

// See XHRUpload
function setTypeInBlob(file) {
  var dataWithUpdatedType = file.data.slice(0, file.data.size, file.meta.type);
  return dataWithUpdatedType;
}
function addMetadata(formData, meta, opts) {
  var allowedMetaFields = Array.isArray(opts.allowedMetaFields) ? opts.allowedMetaFields
  // Send along all fields by default.
  : Object.keys(meta);
  allowedMetaFields.forEach(function (item) {
    formData.append(item, meta[item]);
  });
}
function createFormDataUpload(file, opts) {
  var formPost = new FormData();
  addMetadata(formPost, file.meta, opts);
  var dataWithUpdatedType = setTypeInBlob(file);
  if (file.name) {
    formPost.append(opts.fieldName, dataWithUpdatedType, file.meta.name);
  } else {
    formPost.append(opts.fieldName, dataWithUpdatedType);
  }
  return formPost;
}
var createBareUpload = function createBareUpload(file) {
  return file.data;
};
var _addEventHandlerForFile = /*#__PURE__*/_classPrivateFieldLooseKey("addEventHandlerForFile");
var _addEventHandlerIfFileStillExists = /*#__PURE__*/_classPrivateFieldLooseKey("addEventHandlerIfFileStillExists");
var MiniXHRUpload = /*#__PURE__*/function () {
  function MiniXHRUpload(uppy, opts) {
    _classCallCheck(this, MiniXHRUpload);
    Object.defineProperty(this, _addEventHandlerIfFileStillExists, {
      value: _addEventHandlerIfFileStillExists2
    });
    Object.defineProperty(this, _addEventHandlerForFile, {
      value: _addEventHandlerForFile2
    });
    this.uppy = uppy;
    this.opts = _objectSpread({
      validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
      }
    }, opts);
    this.requests = opts[internalRateLimitedQueue];
    this.uploaderEvents = Object.create(null);
    this.i18n = opts.i18n;
  }
  _createClass(MiniXHRUpload, [{
    key: "getOptions",
    value: function getOptions(file) {
      var _file$xhrUpload;
      var uppy = this.uppy;
      var overrides = uppy.getState().xhrUpload;
      var opts = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, this.opts), overrides || {}), file.xhrUpload || {}), {}, {
        headers: _objectSpread(_objectSpread(_objectSpread({}, this.opts.headers), overrides == null ? void 0 : overrides.headers), (_file$xhrUpload = file.xhrUpload) == null ? void 0 : _file$xhrUpload.headers)
      });
      return opts;
    }
  }, {
    key: "uploadLocalFile",
    value: function uploadLocalFile(file) {
      var _this2 = this;
      var opts = this.getOptions(file);
      return new Promise(function (resolve, reject) {
        // This is done in index.js in the S3 plugin.
        // this.uppy.emit('upload-started', file)

        var data = opts.formData ? createFormDataUpload(file, opts) : createBareUpload(file, opts);
        var xhr = new XMLHttpRequest();
        _this2.uploaderEvents[file.id] = new EventManager(_this2.uppy);
        var timer = new ProgressTimeout(opts.timeout, function () {
          xhr.abort();
          // eslint-disable-next-line no-use-before-define
          queuedRequest.done();
          var error = new Error(_this2.i18n('timedOut', {
            seconds: Math.ceil(opts.timeout / 1000)
          }));
          _this2.uppy.emit('upload-error', file, error);
          reject(error);
        });
        var id = nanoid();
        xhr.upload.addEventListener('loadstart', function () {
          _this2.uppy.log("[AwsS3/XHRUpload] ".concat(id, " started"));
        });
        xhr.upload.addEventListener('progress', function (ev) {
          _this2.uppy.log("[AwsS3/XHRUpload] ".concat(id, " progress: ").concat(ev.loaded, " / ").concat(ev.total));
          // Begin checking for timeouts when progress starts, instead of loading,
          // to avoid timing out requests on browser concurrency queue
          timer.progress();
          if (ev.lengthComputable) {
            _this2.uppy.emit('upload-progress', _this2.uppy.getFile(file.id), {
              uploader: _this2,
              bytesUploaded: ev.loaded,
              bytesTotal: ev.total
            });
          }
        });
        xhr.addEventListener('load', function (ev) {
          _this2.uppy.log("[AwsS3/XHRUpload] ".concat(id, " finished"));
          timer.done();
          // eslint-disable-next-line no-use-before-define
          queuedRequest.done();
          if (_this2.uploaderEvents[file.id]) {
            _this2.uploaderEvents[file.id].remove();
            _this2.uploaderEvents[file.id] = null;
          }
          if (opts.validateStatus(ev.target.status, xhr.responseText, xhr)) {
            var _body = opts.getResponseData(xhr.responseText, xhr);
            var uploadURL = _body[opts.responseUrlFieldName];
            var uploadResp = {
              status: ev.target.status,
              body: _body,
              uploadURL: uploadURL
            };
            _this2.uppy.emit('upload-success', _this2.uppy.getFile(file.id), uploadResp);
            if (uploadURL) {
              _this2.uppy.log("Download ".concat(file.name, " from ").concat(uploadURL));
            }
            return resolve(file);
          }
          var body = opts.getResponseData(xhr.responseText, xhr);
          var error = buildResponseError(xhr, opts.getResponseError(xhr.responseText, xhr));
          var response = {
            status: ev.target.status,
            body: body
          };
          _this2.uppy.emit('upload-error', file, error, response);
          return reject(error);
        });
        xhr.addEventListener('error', function () {
          _this2.uppy.log("[AwsS3/XHRUpload] ".concat(id, " errored"));
          timer.done();
          // eslint-disable-next-line no-use-before-define
          queuedRequest.done();
          if (_this2.uploaderEvents[file.id]) {
            _this2.uploaderEvents[file.id].remove();
            _this2.uploaderEvents[file.id] = null;
          }
          var error = buildResponseError(xhr, opts.getResponseError(xhr.responseText, xhr));
          _this2.uppy.emit('upload-error', file, error);
          return reject(error);
        });
        xhr.open(opts.method.toUpperCase(), opts.endpoint, true);
        // IE10 does not allow setting `withCredentials` and `responseType`
        // before `open()` is called. It’s important to set withCredentials
        // to a boolean, otherwise React Native crashes
        xhr.withCredentials = Boolean(opts.withCredentials);
        if (opts.responseType !== '') {
          xhr.responseType = opts.responseType;
        }
        Object.keys(opts.headers).forEach(function (header) {
          xhr.setRequestHeader(header, opts.headers[header]);
        });
        var queuedRequest = _this2.requests.run(function () {
          xhr.send(data);
          return function () {
            // eslint-disable-next-line no-use-before-define
            timer.done();
            xhr.abort();
          };
        }, {
          priority: 1
        });
        _classPrivateFieldLooseBase(_this2, _addEventHandlerForFile)[_addEventHandlerForFile]('file-removed', file.id, function () {
          queuedRequest.abort();
          reject(new Error('File removed'));
        });
        _classPrivateFieldLooseBase(_this2, _addEventHandlerIfFileStillExists)[_addEventHandlerIfFileStillExists]('cancel-all', file.id, function (_temp) {
          var _ref = _temp === void 0 ? {} : _temp,
            reason = _ref.reason;
          if (reason === 'user') {
            queuedRequest.abort();
          }
          reject(new Error('Upload cancelled'));
        });
      });
    }
  }]);
  return MiniXHRUpload;
}();
export { MiniXHRUpload as default };
function _addEventHandlerForFile2(eventName, fileID, eventHandler) {
  this.uploaderEvents[fileID].on(eventName, function (fileOrID) {
    var _fileOrID$id;
    // TODO (major): refactor Uppy events to consistently send file objects (or consistently IDs)
    // We created a generic `addEventListenerForFile` but not all events
    // use file IDs, some use files, so we need to do this weird check.
    var id = (_fileOrID$id = fileOrID == null ? void 0 : fileOrID.id) != null ? _fileOrID$id : fileOrID;
    if (fileID === id) eventHandler();
  });
}
function _addEventHandlerIfFileStillExists2(eventName, fileID, eventHandler) {
  var _this = this;
  this.uploaderEvents[fileID].on(eventName, function () {
    if (_this.uppy.getFile(fileID)) eventHandler.apply(void 0, arguments);
  });
}